import React from 'react';
import { IntakeFormData } from '../../types/form';

interface Props {
  data: IntakeFormData;
  onChange: (updates: Partial<IntakeFormData>) => void;
}

const inputClass = `
  w-full bg-dark-700 border border-dark-500 rounded-lg px-4 py-3
  text-white text-sm font-body placeholder-gray-600
  focus:outline-none focus:border-lime-400 focus:ring-1 focus:ring-lime-400/20
  transition-all duration-200
`;

const labelClass = "block text-xs font-medium text-gray-300 uppercase tracking-wider mb-2";

const INDUSTRIES = [
  'Construction & Trades', 'Lawn & Landscaping', 'HVAC & Plumbing',
  'Restaurant & Food', 'Health & Wellness', 'Retail & E-commerce',
  'Real Estate', 'Professional Services', 'Beauty & Salon',
  'Automotive', 'Education', 'Non-Profit', 'Entertainment', 'Other',
];

const Step1BusinessInfo: React.FC<Props> = ({ data, onChange }) => {
  return (
    <div className="space-y-5 animate-fade-up">
      <div>
        <h2 className="font-display text-2xl font-semibold text-white mb-1">
          Let's start with the basics.
        </h2>
        <p className="text-sm text-gray-300">Tell us about your business so we can hit the ground running.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <label className={labelClass}>Business Name *</label>
          <input
            type="text"
            className={inputClass}
            placeholder="e.g. Peak Performance Studio"
            value={data.businessName}
            onChange={e => onChange({ businessName: e.target.value })}
          />
        </div>

        <div>
          <label className={labelClass}>Industry *</label>
          <select
            className={inputClass}
            value={data.industry}
            onChange={e => onChange({ industry: e.target.value })}
          >
            <option value="">Select your industry</option>
            {INDUSTRIES.map(ind => (
              <option key={ind} value={ind}>{ind}</option>
            ))}
          </select>
        </div>

        <div>
          <label className={labelClass}>Current Website</label>
          <input
            type="text"
            className={inputClass}
            placeholder="yoursite.com (if any)"
            value={data.website}
            onChange={e => onChange({ website: e.target.value })}
          />
        </div>

        <div>
          <label className={labelClass}>Your Name *</label>
          <input
            type="text"
            className={inputClass}
            placeholder="First & last name"
            value={data.contactName}
            onChange={e => onChange({ contactName: e.target.value })}
          />
        </div>

        <div>
          <label className={labelClass}>Email Address *</label>
          <input
            type="email"
            className={inputClass}
            placeholder="you@yourbusiness.com"
            value={data.contactEmail}
            onChange={e => onChange({ contactEmail: e.target.value })}
          />
        </div>

        <div>
          <label className={labelClass}>Phone Number</label>
          <input
            type="tel"
            className={inputClass}
            placeholder="(540) 000-0000"
            value={data.contactPhone}
            onChange={e => onChange({ contactPhone: e.target.value })}
          />
        </div>

        <div>
          <label className={labelClass}>Business Location</label>
          <input
            type="text"
            className={inputClass}
            placeholder="City, State"
            value={data.location}
            onChange={e => onChange({ location: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};

export default Step1BusinessInfo;
